<div class="d-flex flex-column vh-100">
    <header-bar></header-bar>

    <div class="flex-fill flex-grow-1 flex-shrink-0">
        <router-outlet></router-outlet>
    </div>

    <div class="flex-fill flex-grow-0 flex-shrink-1">
        <footer-bar></footer-bar>
    </div>
</div>